export default "__VITE_ASSET__DcqcYtCx__"